export default function ($filter) {
	'ngInject';
	return function (property) {
		let retValue = '';
		if (property.city) {
			retValue += property.city;
		}
		if (property.district) {
			if (retValue) {
				retValue += ', ';
			}
			const districtText = $filter('translate')('AADAT.district').toLowerCase();
			retValue += property.district + '. ' + districtText;
		}
		return retValue;
	};
}